import React from "react";

const AboutMission = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
          <div>
            <span className="inline-block text-xs text-[#64748B] border border-[#E2E8F0] px-3 py-1 rounded-full mb-4">
              About Invexflow
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A] leading-snug">
              Empowering your business with seamless cashflow solutions
            </h2>
          </div>

          <span className="inline-block mt-4 md:mt-0 bg-[#22C55E] text-white text-xs font-semibold px-3 py-1.5 rounded-full">
            Regulated partners
          </span>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <InfoCard
            title="Our story"
            text="InvexFlow was founded with a simple yet powerful insight:
Businesses don’t fail due to lack of revenue—they fail due to delayed cash flows.

In industries like healthcare and automotive services, providers often wait 30 to 90 days for insurance claim settlements. During this time, operational costs continue to rise, creating a critical liquidity gap.

Having deep roots in banking, digital payments, and financial ecosystems, our founders experienced these inefficiencies firsthand. They recognized an opportunity to build a platform that could:

Digitize invoice validation with insurance companies
Enable banks to finance verified receivables
Provide businesses with instant access to working capital

What started as a concept has evolved into a structured fintech platform—designed to bring speed, transparency, and trust into invoice-based financing.

Today, InvexFlow is on a mission to reshape how businesses manage liquidity—by turning receivables into opportunity."
          />
          <InfoCard
            title="Our values"
            text="At InvexFlow, our values define how we operate, innovate, and build trust across the ecosystem:

1. Trust & Transparency

We ensure every transaction is backed by verified data, clear processes, and full visibility for all stakeholders.

2. Speed with Integrity

While we enable fast access to funds, we never compromise on compliance, validation, and risk management.

3. Customer-Centric Innovation

We design solutions that solve real business problems—focused on simplicity, efficiency, and measurable impact.

4. Partnership-Driven Growth

We believe in collaboration—with banks, insurers, and businesses—to build a sustainable financial ecosystem.

5. Financial Inclusion

We are committed to enabling underserved segments of the economy by improving access to structured financing."
          />
          <InfoCard
            title="Security"
            text="At InvexFlow, security is at the core of everything we do. We operate with bank-grade infrastructure and compliance standards to ensure the highest level of data protection and transaction integrity.

Data Protection

All sensitive data is encrypted using advanced encryption protocols, ensuring confidentiality and secure transmission across the platform.

Verified Transactions

Invoices are validated through integrated workflows with insurance companies and financial institutions, reducing fraud risk and ensuring authenticity.

Regulatory Alignment

Our processes are designed in line with financial regulations and industry best practices, ensuring compliance with local and international standards.

Secure Fund Flows

All financial transactions are routed through regulated banking channels, ensuring transparency, auditability, and security of funds.

Access Control & Monitoring

We implement strict access controls, real-time monitoring, and audit trails to safeguard against unauthorized activities."
          />
        </div>

       

      </div>
    </section>
  );
};

/* ---------- Subcomponents ---------- */

const InfoCard = ({ title, text }) => (
  <div className="border border-[#E2E8F0] rounded-xl p-6">
    <h4 className="text-sm font-semibold text-[#0F172A] mb-2">
      {title}
    </h4>
    <p className="text-sm text-[#64748B] leading-relaxed">
      {text}
    </p>
  </div>
);



export default AboutMission;
